angular.module('impactx.downloadbutton').controller('DownloadButtonCtrl', ['$scope', 'dataGen', '$route', 'ixaPrintService', DownloadButtonCtrl]);

function DownloadButtonCtrl($scope, dataGen, $route, ixaPrintService) {

    this.download = function() {
        var urlExtension = $scope.entryPointParam ? "/" + $scope.entryPointParam : '';
        ixaPrintService.download($scope.printToken, $scope.contentType, urlExtension).then(function() {
                if($scope.action) {
                    if (typeof $scope.action === 'function') {
                        $scope.action();
                    }
                }
                else {
                    $route.reload();
                }
            },
            {responseType: 'arraybuffer'}
        );
    };

    this.hasToken = function () {
        if (!$scope.printToken && $scope.printTokenFunction && typeof $scope.printTokenFunction === "function") {
            $scope.printToken = $scope.printTokenFunction();
        }
        return !!$scope.printToken;
    }
}
